export default __webpack_public_path__ + "static/media/fish_sample.2b1830d6.jpg";